module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAZ0lEQVQ4EaXBMQ7DABACweX/jybQucDSRZ4RH4mPxODgQMXg4EDF4OBAxeDgQMXg4EHBCzE4eFDwQgwODlQMDg5UDA4OVAwODlT8wcGDij84eFAxODhQMTg4UDE4OFAxODhQ8ZH46Ad7gkAVjgGl7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_05.png
// module id = 238
// module chunks = 0